// =====================================================================
// DATA LOADER
// Carica tariffe e parametri di tutte le compagnie attive.
// Cache leggera in memoria.
// =====================================================================
import { supabase } from './supabase'

let cache = null

export async function loadTariffe(force = false) {
  if (cache && !force) return cache

  const [
    eirTassi, eirParametri, eirDurate, eirZone,
    province, compagnie, standalone,
    lvTassi, lpTassi, lpZone,
    covTassi, covZone,
    qxTassi, qxZone,
    sgTassi, sgZone,
    compParams, paramGlob,
    compDocumenti,
  ] = await Promise.all([
    supabase.from('eir_tassi').select('*'),
    supabase.from('eir_parametri').select('*'),
    supabase.from('eir_coeff_durata').select('*'),
    supabase.from('eir_zone_province').select('*'),
    supabase.from('province').select('*').order('nome'),
    supabase.from('compagnie').select('*').order('ordine'),
    supabase.from('standalone_prodotti').select('*').eq('attivo', true),
    supabase.from('lloyd_volante_tassi').select('*'),
    supabase.from('lloyd_plus_tassi').select('*'),
    supabase.from('lloyd_plus_zone_province').select('*'),
    supabase.from('covea_tassi').select('*'),
    supabase.from('covea_zone_province').select('*'),
    supabase.from('quixa_tassi').select('*'),
    supabase.from('quixa_zone_province').select('*'),
    supabase.from('sogessur_tassi').select('*'),
    supabase.from('sogessur_zone_province').select('*'),
    supabase.from('compagnia_parametri').select('*'),
    supabase.from('parametri_globali').select('*'),
    supabase.from('compagnia_documenti').select('*').order('ordine'),
  ])

  // Mappe parametri
  const eirPar = {}
  for (const r of (eirParametri.data || [])) eirPar[r.chiave] = parseFloat(r.valore)
  const eirCD = {}
  for (const r of (eirDurate.data || [])) eirCD[r.mesi] = parseFloat(r.coefficiente)
  const eirZP = {}
  for (const r of (eirZone.data || [])) eirZP[r.sigla] = r.zona

  const lpZP = {}
  for (const r of (lpZone.data || [])) lpZP[r.sigla] = r.zona
  const covZP = {}
  for (const r of (covZone.data || [])) covZP[r.sigla] = r.zona
  const qxZP = {}
  for (const r of (qxZone.data || [])) qxZP[r.sigla] = r.zona
  const sgZP = {}
  for (const r of (sgZone.data || [])) sgZP[r.sigla] = r.zona

  // compagnia_parametri raggruppati per compagnia
  const paramComp = {}
  for (const r of (compParams.data || [])) {
    if (!paramComp[r.codice_compagnia]) paramComp[r.codice_compagnia] = {}
    paramComp[r.codice_compagnia][r.chiave] = parseFloat(r.valore)
  }

  const parGlob = {}
  for (const r of (paramGlob.data || [])) parGlob[r.chiave] = parseFloat(r.valore)

  // Documenti raggruppati per compagnia
  const documentiCompagnia = {}
  for (const r of (compDocumenti.data || [])) {
    if (!documentiCompagnia[r.codice_compagnia]) documentiCompagnia[r.codice_compagnia] = []
    documentiCompagnia[r.codice_compagnia].push(r)
  }

  cache = {
    province: province.data || [],
    compagnie: compagnie.data || [],
    standalone: standalone.data || [],
    parametriGlobali: parGlob,
    parametriCompagnia: paramComp,
    documentiCompagnia,

    EIR: {
      tassi: eirTassi.data || [],
      parametri: eirPar,
      coeffDurata: eirCD,
      zoneProvince: eirZP,
    },
    LLOYD_VOLANTE: {
      tassi: lvTassi.data || [],
    },
    LLOYD_PLUS: {
      tassi: lpTassi.data || [],
      zoneProvince: lpZP,
    },
    COVEA: {
      tassi: covTassi.data || [],
      zoneProvince: covZP,
    },
    QUIXA: {
      tassi: qxTassi.data || [],
      zoneProvince: qxZP,
    },
    SOGESSUR: {
      tassi: sgTassi.data || [],
      zoneProvince: sgZP,
    },
  }
  return cache
}

// Backward-compat
export const loadTariffeEIR = loadTariffe

export function clearTariffeCache() { cache = null }

export function provinciaToZona(sigla, zoneProvince) { return zoneProvince[sigla] || null }

export function provinciaToRegione(sigla, province) {
  const p = province.find(x => x.sigla === sigla)
  return p?.regione || null
}
